import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export class VariantNextOpModel {
    presentOperation: OperationTypeEnum;
    variantId: number;
    plantId: number;

    constructor(presentOperation: OperationTypeEnum,variantId: number,plantId: number){
        this.presentOperation = presentOperation;
        this.variantId = variantId;
        this.plantId = plantId;
    }
}